import Course from "@/components/course";

const CoursePage = () => (
  <div className="container">
    <Course />
  </div>
);

export default CoursePage;
